import { QScrollBar } from "../CoreApp/QScrollBar";
import { enumScrollBarType } from "../constants";

export function AddFramelessScrollbar(parent, portPanel) {
  parent.fScrollBarV = new QScrollBar();
  parent.PushElement(parent.fScrollBarV);
  parent.fScrollBarV.InitScrollBar(parent, portPanel, enumScrollBarType.vertical);
  parent.fHasVertScrollBar = false;
}
